import r2wc from "@r2wc/react-to-web-component";
import { ResultsContainer } from "../components/ResultsContainer";

const ResultsWebComponent = r2wc(ResultsContainer, {
  props: {
    apiKey: "string",
    fleetId: "string",
    apiBaseUrl: "string",
    searchParams: "json",
    theme: "string",
    className: "string",
    primaryColor: "string",
    showSearchBar: "boolean",
    onVehicleSelect: "function",
    onBackToSearch: "function",
    showBackButton: "boolean",
    currency: "string",
    showReserveButton: "boolean",
  },
  events: {
    onVehicleSelect: { bubbles: true, composed: true },
    onBackToSearch: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-results")) {
  customElements.define("fm-results", ResultsWebComponent);
}
